module.exports = __webpack_public_path__ + "assets/barcode.103c3db5.svg";